import { useSnapshot } from "valtio";

import React from "react";

import { store } from "@store";

import {
    kioskStore,
    setChosenTransition,
    setIsSubStepActionButtonsActive,
    setIsSubStepIconActive,
    setIsSubStepInformationMessageActive,
    setIsSubStepLogoActive,
    setIsSubStepTopBannerActive,
    setKeyboardInputsValues,
    setNumericKeyboardInputValue,
    setPseudoNameValue,
    setSubStepActionButtons,
    setSubStepIconId,
    setSubStepInformationMessageItems,
} from "@pages/Kiosk/store";

import { EmailStep } from "../EmailStep";
import { LoyaltyCardStep } from "../LoyaltyCardStep";
import { PhoneNumberStep } from "../PhoneNumberStep";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const RoleViews: any = {
    phoneNumber: PhoneNumberStep,
    emailAndPassword: EmailStep,
};

export function AuthenticationModeConsommation(): JSX.Element {
    const {
        selectedAuthMode,
        project: {
            template: {
                pages: { subSteps },
            },
        },
    } = useSnapshot(kioskStore);
    const { transitions } = useSnapshot(store);

    React.useEffect(() => {
        if (
            (subSteps[selectedAuthMode] as PageType).header.icon !== undefined
        ) {
            setIsSubStepIconActive(
                (
                    (subSteps[selectedAuthMode] as PageType).header
                        .icon as IconType
                ).active
            );
            setSubStepIconId(
                (
                    (subSteps[selectedAuthMode] as PageType).header
                        .icon as IconType
                ).id
            );
        }
        setIsSubStepInformationMessageActive(
            (subSteps[selectedAuthMode] as PageType).header.informationMessage
                .active
        );
        setSubStepInformationMessageItems(
            (subSteps[selectedAuthMode] as PageType).header.informationMessage
                .languages
        );
        setIsSubStepTopBannerActive(
            (subSteps[selectedAuthMode] as PageType).topBanner.active
        );
        setIsSubStepLogoActive(
            (subSteps[selectedAuthMode] as PageType).topBanner.logo.active
        );
        setIsSubStepActionButtonsActive(
            (subSteps[selectedAuthMode] as PageType).actionsButtons.active
        );
        setSubStepActionButtons(
            (subSteps[selectedAuthMode] as PageType).actionsButtons.items
        );

        setChosenTransition(
            transitions[(subSteps[selectedAuthMode] as PageType).animation]
        );
        setNumericKeyboardInputValue("");
        setPseudoNameValue("");
        setKeyboardInputsValues({});
    }, []);
    const CurrentView =
        RoleViews[selectedAuthMode] !== undefined
            ? RoleViews[selectedAuthMode]
            : LoyaltyCardStep;

    return (
        <React.Fragment>
            <CurrentView />
        </React.Fragment>
    );
}
